@if (events) {
  <div class="container">
    <div class="row">
      <div class="col">
        <ngx-timeline [events]="events" [innerEventCustomTemplate]="descriptionTemplate"
          [periodCustomTemplate]="periodCustomTemplate"
          [dateInstantCustomTemplate]="dateInstantCustomTemplate"
          [centerIconCustomTemplate]="centerIconCustomTemplate"
          [changeSide]="NgxTimelineEventChangeSide.ALL_IN_GROUP">
        </ngx-timeline>
        <!--            <vertical-timeline>-->
        <!--                <vertical-timeline-card *ngFor="let task of process?.tasks" [timeString]="task.status"-->
        <!--                    [color]="getColor(task.status)">-->
<!--                    <h3 [ngClass]="{'programmation': task.step==='PROGRAMMATION', 'evaluation': task.step==='EVALUATION',-->

<!--                        'execution': task.step==='EXECUTION',-->
<!--                        'draft': task.status==='DRAFT'}">{{task.step}}</h3>-->

<!--                    <a [routerLink]="['/process/'+process?.id+'/'+task.key]" class="btn btn-outline-primary">-->
<!--                        {{task.name}}-->
<!--                    </a>-->
<!--                </vertical-timeline-card>-->
<!--            </vertical-timeline>-->
        </div>
    </div>
</div>
}

<!--<ng-template #periodCustomTemplate let-period=period let-index=index let-event=event>-->
<!--&lt;!&ndash;&lt;!&ndash;    <div *ngIf="event.isApproved">&ndash;&gt;&ndash;&gt;-->

<!--&lt;!&ndash;    <div class="col col-center desktop col-period"><div class="center-inner">&ndash;&gt;-->
<!--&lt;!&ndash;    <div [ngClass]="{'transparent first-line': index}" class="line"></div>&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="period-container">&ndash;&gt;-->
<!--&lt;!&ndash;        <div  class="period-inner-container"><span >March 2023</span></div></div><div class="line"></div>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;    </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="line"></div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--&lt;!&ndash;    <span class="timeline-box" [ngStyle]="{'background-color': getColor(event.status)}">sss</span>&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="col col-center desktop col-period"><div class="center-inner"><div class="line transparent first-line"></div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="period-container"><div class="period-inner-container">&ndash;&gt;-->
<!--&lt;!&ndash;            <span >March 2023</span></div></div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="line"></div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--</ng-template>-->
<ng-template #eventCustomTemplate let-event=event let-colSidePosition=colSidePosition>
<!--    <div class="event" (click)="handleClick(event)">-->
<!--        {{event | json}}-->
<!--    </div>-->
</ng-template>
<ng-template #descriptionTemplate let-event=event.eventInfo let-colSidePosition=colSidePosition>
    <h3 [ngClass]="{'programmation': event.title==='PROGRAMMATION', 'evaluation': event.title==='EVALUATION',
                     'execution': event.title==='EXECUTION', 'draft': event.status==='DRAFT'}">{{event.title}}</h3>
  <a [routerLink]="['/process/'+process?.id+'/'+event.key]" class="btn btn-outline-primary">{{event.description}}</a>
</ng-template>
<ng-template #dateInstantCustomTemplate let-item=item>
  <span class="timeline-box" [ngStyle]="{'background-color': getColor(item.status)}">{{item.status}}</span>
</ng-template>
<!--<ng-template #centerIconCustomTemplate let-index=index let-event=event.eventInfo>-->
<!--&lt;!&ndash;    <div class="icon-container" (loadstart)="drawCircle(event.key, getColor(event.status))">&ndash;&gt;-->
<!--&lt;!&ndash;        <canvas id="{{event.key}}"></canvas>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="icon-container">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="icon"></div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--</ng-template>-->

